import UseScrollAnimation from "../Elements/ScrollAnimation";
// import ThreeTestimonials from "./Page_Sections/threeTestimonials";
// import AboutThePractitioner from "./Page_Sections/aboutThePractitioner";

const sections = [
  {
    h: "Information We Collect",
    p: "We collect information you provide directly — your name, contact details, health history, and any messages you send us through the contact form or intake paperwork.",
  },
  {
    h: "How We Use Your Information",
    p: "Your information is used solely to provide homeopathic consultations, communicate with you about your care, and maintain accurate clinical records as required by professional standards.",
  },
  {
    h: "How We Protect Your Information",
    p: "All client records are stored securely with appropriate technical and physical safeguards. Telehealth sessions are conducted over encrypted, HIPAA-conscious platforms.",
  },
  {
    h: "Sharing of Information",
    p: "We do not sell, rent, or share your personal information with third parties for marketing. Information may be shared only with your written consent or where required by law.",
  },
  {
    h: "Your Rights",
    p: "You may request a copy of your records, ask for corrections, or withdraw consent at any time by contacting us directly.",
  },
  {
    h: "Cookies & Website Analytics",
    p: "Our website uses minimal, privacy-respecting analytics to understand site usage. No personally identifying information is collected through these tools.",
  },
  {
    h: "Updates to This Policy",
    p: "We may update this policy from time to time. The most current version will always be available on this page.",
  },
];

const PrivacyPolicy = () => {
  UseScrollAnimation(); // ✅ just call it

  return (
    <>
      <div className="HomeParent">
        <div className="HomeBox ">
          <section className="Disclaimer_Section">
            <div className="Disclaimer_SectionBox">
              <div className="Disclaimer_Section_TitleHeadingContent">
                <p className="Disclaimer_Section_Title animate-top">
                  Privacy Policy
                </p>
                <span className="Disclaimer_Section_Heading animate-top">
                  Your privacy, <br />
                  fully respected.
                </span>
                <p className="Disclaimer_Section_Content animate-top">
                  {`Last updated: ${new Date().getFullYear()}`}
                </p>
              </div>
            </div>
          </section>
          <section className="Disclaimer_Section00">
            <div className="Disclaimer_SectionParent00">
              {sections.map((s) => (
                <div className="Disclaimer_SectionBox00">
                  <h2 className="Disclaimer_Section_Heading00 animate-top">
                    {s.h}
                  </h2>
                  <p className="Disclaimer_Section_Content00 animate-top">
                    {s.p}
                  </p>
                </div>
              ))}
              <span className="Disclaimer_Section_BottomContent animate-top">
                For any questions about this policy, please contact us at
                info@mysite.com.
              </span>
            </div>
          </section>
          {/* <ThreeTestimonials /> */}

          {/* <AboutThePractitioner /> */}
        </div>
      </div>
    </>
  );
};

export default PrivacyPolicy;
